/* eslint-disable no-shadow */
import * as PropTypes from "prop-types"
import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import Cta from "./Cta"
import Modal from "./Modal"
import Toggle from "./Toggle"
import { openModal } from "../slices/modalSlice" // ✅ RTK slice action
import { BUTTON, MEDIUM } from "../helpers/constants"

const CookieConsent = ({ onAccept, cookiePolicy }) => {
  const dispatch = useDispatch()

  const homePage = useSelector(state => state.data.homePage)
  const translations = useSelector(state => state.data.translations)

  const {
    cookieConsentContent: {
      disclaimer,
      cookiePolicyLink,
      buttons: { accept, allowAll, confirm, manage },
      necessary,
      functional,
      analytics,
      marketing
    } = {}
  } = homePage || {}

  const [isManagementPanelOpen, setIsManagementPanelOpen] = useState(false)
  const [consent, setConsent] = useState({
    necessary: "granted",
    functional: "granted",
    analytics: "granted",
    marketing: "granted"
  })

  const handleManageButtonClick = () => setIsManagementPanelOpen(true)
  const handleConfirmClick = () => onAccept(consent)
  const handleAllowAllClick = () =>
    onAccept({
      necessary: "granted",
      functional: "granted",
      analytics: "granted",
      marketing: "granted"
    })

  const handleChange = (key, value) => setConsent({ ...consent, [key]: value })

  const confirmButton = {
    type: BUTTON,
    size: MEDIUM,
    text: confirm,
    action: handleConfirmClick,
    className: "confirm-button"
  }

  const manageButton = {
    type: BUTTON,
    size: MEDIUM,
    text: manage,
    action: handleManageButtonClick,
    className: "manage-button"
  }

  const allowButton = {
    type: BUTTON,
    size: MEDIUM,
    text: allowAll,
    action: handleAllowAllClick,
    className: "allow-button"
  }

  const acceptButton = {
    type: BUTTON,
    size: MEDIUM,
    text: accept,
    action: handleAllowAllClick,
    className: "allow-button"
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__inner">
        <div className="cookie-consent__infopanel">
          <div className="cookie-consent__disclaimer">
            <svg width="70" height="70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="70" height="70" rx="4" fill="#F1F0EC" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.965 18.25h.694l1.4 4.988 3.65.002.36 3.318 5.372.119-.001 4.03.53.085 1.281.217 1.26.226 1.856.351.11.618c.165.912.244 1.844.244 2.803 0 9.254-7.502 16.755-16.756 16.755-9.254 0-16.755-7.501-16.755-16.755 0-9.1 7.253-16.505 16.294-16.75l.461-.006Z"
                fill="#0B0B0B"
              />
            </svg>
            <p className="cookie-consent__text">
              {disclaimer}
              <button type="button" onClick={() => dispatch(openModal({ content: cookiePolicy }))}>
                {cookiePolicyLink}
              </button>
            </p>
          </div>
          <div className={`cookie-consent__buttons ${isManagementPanelOpen ? " cookie-consent__buttons--open" : ""}`}>
            <Cta {...(isManagementPanelOpen ? confirmButton : manageButton)} />
            <Cta {...(isManagementPanelOpen ? allowButton : acceptButton)} />
          </div>
        </div>
        {isManagementPanelOpen && (
          <div className="cookie-consent__managepanel">
            <div className="cookie-consent__toggles">
              <Toggle
                key="necessary"
                onChange={value => handleChange("necessary", value)}
                isOn={consent.necessary}
                disabled
                title={necessary?.title}
                body={necessary?.description}
              />
              <Toggle
                key="functional"
                onChange={value => handleChange("functional", value)}
                isOn={consent.functional}
                title={functional?.title}
                body={functional?.description}
              />
              <Toggle
                key="analytics"
                onChange={value => handleChange("analytics", value)}
                isOn={consent.analytics}
                title={analytics?.title}
                body={analytics?.description}
              />
              <Toggle
                key="marketing"
                onChange={value => handleChange("marketing", value)}
                isOn={consent.marketing}
                title={marketing?.title}
                body={marketing?.description}
              />
            </div>
            <div className="cookie-consent__managementbuttons">
              <Cta {...confirmButton} />
              <Cta {...(isManagementPanelOpen ? allowButton : acceptButton)} />
            </div>
          </div>
        )}
      </div>
      <Modal translations={translations} />
    </div>
  )
}

CookieConsent.propTypes = {
  onAccept: PropTypes.func.isRequired,
  cookiePolicy: PropTypes.string.isRequired
}

export default CookieConsent
